import { hot } from 'react-hot-loader';

import { fiscalYearExperimentsUrl } from '../../../urls';

const fisYear2Year = (year) => {
  let title = year;
  if (year === 2019) {
    title = year.toString() + '（平成31／令和元）年度';
  } else if (year > 2019) {
    title = year.toString() + '（令和' + (year - 2018).toString() + '）年度';
  } else {
    title = year.toString() + '（平成' + (year - 1988).toString() + '）年度';
  }
  return title;
};

const FiscalYearList = ({ years }) => {
  const descendingOrderYears = years.sort((a, b) => (a > b ? -1 : 1));
  const li_list = descendingOrderYears.map((year) => {
    return (
      <>
        {/* <Button className='fiscalYear' variant="outline-success" href={fiscalYearExperimentsUrl(year)}>{year}</Button> */}
        <a href={fiscalYearExperimentsUrl(year)} className="w-25 list-group-item list-group-item-action list-group-item-success">{fisYear2Year(year)}</a>
      </>
    );
  });

  return (
    <>
      <ul className="list-group">
        {li_list}
      </ul>
    </>
  );
};

export default hot(module)(FiscalYearList);
export { fisYear2Year };